// import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@workspace/web-ui/components/select"
// import { statusOptions } from "../../libs/filters"

// interface StatusFiltersProps {
//     status: string
//     setStatus: React.Dispatch<React.SetStateAction<string>>
// }

// export const StatusFilters = ({ status, setStatus }: StatusFiltersProps) => {
//     const handleStatusChange = (value: string) => {
//         setStatus(value)
//     }

//     return (
//         <Select value={status} onValueChange={handleStatusChange}>
//             <SelectTrigger className="w-fit button-primary !px-4 !py-3">
//                 <SelectValue placeholder="Status" />
//             </SelectTrigger>
//             <SelectContent>
//                 {statusOptions.map((statusItem) => (
//                     <SelectItem 
//                         key={statusItem.value} 
//                         value={statusItem.value}
//                     >
//                         {statusItem.label}
//                     </SelectItem>
//                 ))}
//             </SelectContent>
//         </Select>
//     )
// }

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@workspace/web-ui/components/select"
import { statusOptions } from "../../libs/filters"
import { EncounterFilterStatus } from "../../types"
import { useParams } from "@tanstack/react-router"

interface StatusFiltersProps {
    status: EncounterFilterStatus
    setStatus: React.Dispatch<React.SetStateAction<EncounterFilterStatus>>
}

export const StatusFilters = ({ status, setStatus }: StatusFiltersProps) => {
    const handleStatusChange = (value: EncounterFilterStatus) => {
        setStatus(value)
    }

    const { program } = useParams({ strict: false })

    const filteredStatusOptions = statusOptions.filter((statusItem) => {
        if (program === "weight-loss") {
            return statusItem.value !== "fulfilled" && statusItem.value !== "partially_fulfilled" && statusItem.value !== "rejected"
        }
        if (program === "urgent-care") {
            return statusItem.value !== "action_needed"
        }
        return true
    })

    return (
        <Select value={status} onValueChange={handleStatusChange}>
            <SelectTrigger className="w-fit button-primary !px-4 !py-3">
                <SelectValue placeholder="Status" />
            </SelectTrigger>
            <SelectContent>
                {filteredStatusOptions.map((statusItem) => (
                    <SelectItem 
                        key={statusItem.value} 
                        value={statusItem.value as EncounterFilterStatus} // cast to ensure type safety
                    >
                        {statusItem.label}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    )
}


